<script>
import { QNImageUtil } from '@/utils'

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'game-summary',

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
	props: {
        /* The game title string */
        title: String,
        /* The game time string */
        time: String,
        /* The home team name string */
        homeTeamName: String,
        /* The home team badge string */
        homeTeamBadge: String,
        /* The home team score number */
        homeTeamScore: Number,
        /* The away team name string */
        awayTeamName: String,
        /* The away team badge string */
        awayTeamBadge: String,
        /* The away team score number */
        awayTeamScore: Number
	},

    computed: {
        isScoreExisted() {
            console.log('isScoreExisted', this.homeTeamScore, this.awayTeamScore)
            if (this.homeTeamScore != null && this.awayTeamScore != null) {
                return true
            }
            else {
                return false
            }
        }
    },

    methods: {
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
			return QNImageUtil.imageView(img, w, h)
		}
    }
}
</script>

<template>
    <div class="game-summary">
        <div class="summary-section">
            <div class="title">
                <span class="label">{{ title }}</span>
            </div>
            <div class="time">
                <span class="label">{{ time }}</span>
            </div>
        </div>
        <div class="game-teams">
            <span class="team-name home-name truncate">{{ homeTeamName }}</span>
            <img v-if="homeTeamBadge" class="home-logo" :src="adjustImageSize(homeTeamBadge, 80, 80)"/>
            <img v-else class="home-logo" src="@/assets/match-team-game/logo-symbol.svg"/>
            <span v-if="!isScoreExisted" class="versus">VS</span>
            <span v-else class="score-unit">
                <span class="home-score">{{ homeTeamScore }}</span>
                <span class="score-separator">:</span>
                <span class="away-score">{{ awayTeamScore }}</span>
            </span>
            <img v-if="awayTeamBadge" class="away-logo" :src="adjustImageSize(awayTeamBadge, 80, 80)"/>
            <img v-else class="away-logo" src="@/assets/match-team-game/logo-symbol.svg"/>
            <span class="team-name away-name truncate">{{ awayTeamName }}</span>
        </div>
    </div>
</template>

<style scoped>
.truncate {
	word-break: break-all;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.game-summary {
    height: 100%;
    background: #E6F7F2;
    padding-bottom: 18px;
}
.title {
    padding-top: 15px;
    width: 100%;
    text-align: center;
}
.title .label {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    font-weight: normal;
    line-height: 11px;
    letter-spacing: normal;
    color: #3D3D3D;
}
.time {
    padding-top: 4px;
    text-align: center;
}
.time .label {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: normal;
    color: #3D3D3D;
}
.game-teams {
    padding-top: 10px;
    height: 40px;
    width: 100%;
}
.game-teams * {
    display: inline-block;
    vertical-align: middle;
}
.game-teams img {
    width: 40px;
    height: 40px;
    border-radius: 20px;
}
.game-teams .team-name {
    font-family: Source Han Sans;
    font-size: 14px;
    font-weight: 350;
    line-height: 16px;
    letter-spacing: normal;
    color: #3D3D3D;
}
.versus {
    margin-left: 22px;
    margin-right: 22px;
    font-family: Source Han Sans;
    font-size: 26px;
    font-weight: 350;
    line-height: normal;
    text-align: center;
    letter-spacing: 0.1em;
    color: #3D3D3D;
}
.score-unit {
    width: 79px;
    font-family: Source Han Sans;
    font-size: 26px;
    font-weight: 350;
    line-height: normal;
    letter-spacing: normal;
    color: #3D3D3D;
}
.home-score {
    width: 30px;
    margin-left: 3px;
    text-align: right;
    overflow: hidden;
}
.score-separator {
    width: 7px;
    margin-left: 3px;
    margin-right: 3px;
    text-align: center;
}
.away-score {
    width: 30px;
    margin-right: 3px;
    text-align: left;
    overflow: hidden;
}
.home-logo {
    margin-left: 11px;
}
.away-logo {
    margin-right: 11px;
}
.team-name {
    width: 95px;
}
.home-name {
    text-align: right;
    margin-left: 2px;
}
.away-name {
    text-align: left;
    /* avoid the overflow issue */
    width: auto;
    max-width: 93px;
}
</style>